import { render, staticRenderFns } from "./AddANewCar.vue?vue&type=template&id=6242a4f0&scoped=true&lang=html&"
import script from "./AddANewCar.vue?vue&type=script&lang=js&"
export * from "./AddANewCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242a4f0",
  null
  
)

export default component.exports